import { isAnalysisMethod } from "../../typeGuards/isAnalysisMethod";
import { isAnnotationVariable } from "../../typeGuards/isAnnotationVariable";
import { isGroupingFactor } from "../../typeGuards/isGroupingFactor";
import { isObjectRecord } from "../../typeGuards/isObjectRecord";
import { isOperation } from "../../typeGuards/isOperation";
import { ArsSidebarItemData } from "../interface";

/**
 * Type guard for ArsTable draggable sidebar payload items.
 *
 * @param obj - Unknown parsed payload item
 * @returns True when the value is a supported ArsTable sidebar item
 */
export const isArsSidebarItemData = (obj: unknown): obj is ArsSidebarItemData => {
  if (!isObjectRecord(obj) || !("kind" in obj) || !("dropItem" in obj)) {
    return false;
  }

  // Check sub object
  if (obj.kind === "groupingFactor") {
    return isGroupingFactor(obj.dropItem);
  } else if (obj.kind === "analysisMethod") {
    return isAnalysisMethod(obj.dropItem);
  } else if (obj.kind === "operation") {
    return isOperation(obj.dropItem);
  } else if (obj.kind === "variable") {
    return isAnnotationVariable(obj.dropItem);
  }

  // Not good
  return false;
};
